// protected.jsx
import { Navigate } from "react-router-dom";
import useAuth from "../pages/useAuth";

const ProtectedRoute = ({ children, roles = [] }) => {
  const { isAuthenticated, role } = useAuth();

  // Redirect to login if not authenticated
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // Redirect to unauthorized if role mismatch
  if (roles.length > 0 && !roles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Authorized, render the child component
  return children;
};

export default ProtectedRoute;
